module.exports = __webpack_public_path__ + "static/media/w-logo.68d240b0.png";